/**
 * Mindestangaben, ohne die ein Auftragsentwurf nicht gespeichert werden darf. Reiner UX-Vorab-Check
 * für die Speichern-Buttons und das Verwerfen leerer Entwürfe — maßgeblich ist der Server
 * (422 `AUFTRAG_PATIENTENKENNUNG_ERFORDERLICH`).
 */
export function hatEntwurfMindestangaben(patientReference: string | null | undefined): boolean {
  return typeof patientReference === 'string' && patientReference.trim().length > 0;
}
